import { ActivatedRoute, Router } from '@angular/router';
import { UICategory, UILoggerSingleton } from '../../../../common/js/logger/UILoggerSingleton';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { AmorphicService } from '../amorphic/amorphic.service';
import { BaseLoginService } from '../login/base-login.service';
import { Auth0Service } from './auth0.service';

export function authenticationServiceFactory(
  windowService: WindowService,
  route: ActivatedRoute,
  router: Router,
  amorphicService: AmorphicService,
  auth0Service: Auth0Service,
  legacyLoginService: BaseLoginService
) {
  const isAuth0Enabled = windowService.nativeWindow.controller.isAuth0Enabled;

  UILoggerSingleton.getInstance().info(
    {
      module: 'authentication.service.provider',
      function: 'authenticationServiceFactory',
      category: UICategory.security,
      data: {
        isAuth0Enabled: isAuth0Enabled,
      },
    },
    'Factory Creation'
  );

  if (isAuth0Enabled) {
    return auth0Service;
  } else {
    return legacyLoginService;
  }
}
